import React from "react";

export default function SQLServer_ISDATE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ISDATE</h1>
      <p>This is the SQLServer_ISDATE component generated from the SQL JSON.</p>
    </div>
  );
}
